export const yieldToMain = () =>
  new Promise((resolve) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(resolve, { timeout: 2000 });
    } else {
      setTimeout(resolve, 0);
    }
  });
